import { type RefObject, useEffect, useState } from "react";

/**
 * Live content-box height of `ref`. Used so the widget chart can pass a numeric
 * Highcharts height and skip map-panel legend auto-grow.
 */
export function useElementHeight(ref: RefObject<HTMLElement | null>): number | undefined {
  const [height, setHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return;

    const update = () => {
      const next = el.clientHeight;
      setHeight(next > 0 ? next : undefined);
    };
    update();

    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);

  return height;
}
